export const FETCH_MULTILEVEL_APPROVAL_REQUEST = 'FETCH_MULTILEVEL_APPROVAL_REQUEST';
export const FETCH_MULTILEVEL_APPROVAL_SUCCESS = 'FETCH_MULTILEVEL_APPROVAL_SUCCESS';
export const FETCH_MULTILEVEL_APPROVAL_FAILURE = 'FETCH_MULTILEVEL_APPROVAL_FAILURE';

export const SAVE_MULTILEVEL_APPROVAL_REQUEST = 'SAVE_MULTILEVEL_APPROVAL_REQUEST';
export const SAVE_MULTILEVEL_APPROVAL_SUCCESS = 'SAVE_MULTILEVEL_APPROVAL_SUCCESS';
export const SAVE_MULTILEVEL_APPROVAL_FAILURE = 'SAVE_MULTILEVEL_APPROVAL_FAILURE';

export const TOGGLE_APPROVAL_STATUS_REQUEST = 'TOGGLE_APPROVAL_STATUS_REQUEST';
export const TOGGLE_APPROVAL_STATUS_SUCCESS = 'TOGGLE_APPROVAL_STATUS_SUCCESS';
export const TOGGLE_APPROVAL_STATUS_FAILURE = 'TOGGLE_APPROVAL_STATUS_FAILURE';

